import { Component, OnInit, Input } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import {AppComponent} from '../../app.component';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl } from '@angular/forms';
import { element } from 'protractor';
import { AlertService } from '../../alertpopup/_alert';
export interface ParanData {
  filter: string;
  AdvanceSearch: any;
  Type: string;
  RequestType: string;
  ReportConfigId: any;
}
@Component({
    selector: 'app-column-selection',
    templateUrl: './column-selection.component.html',
    styleUrls: ['./column-selection.component.css'],
    standalone: false
})

export class ColumnSelectionComponent implements OnInit {
  @Input() formData: FormData[];
  @Input() Cdata: ColumnData[];
  form: FormGroup;
  url: string;
  Parenturl: string;
  pageurl: string;
  MsgType: number;
  DisplayMessage: string;
  CallFunctionOnCloseModal: any;
  UserID: string;
  RepID: string;
  Columnnos: string;
  SeqNos: string;
  OrderBySeqs: string;
  Type: number;
  bchkAll: boolean;
  chkAll: string;
  ReportConfigId: number;
  options = {
    autoClose: true,
    keepAfterRouteChange: false
};
  constructor(private router: Router, private http: HttpClient, private formBuilder: FormBuilder, protected alertService: AlertService) {
    this.url = AppComponent.baseURL;
  }

  ngOnInit() {
    this.pageurl = this.router.url;
    let arrurl = this.pageurl.split('/');
    this.RepID = arrurl[2];
    this.Type = Number(arrurl[3]);
    this.ReportConfigId= Number(arrurl[4]);
    this.bchkAll = true;
    this.FetchColumnList(this.RepID, this.Type);
  }

  FetchColumnList( RepID: string, Type: number) {

    let ParanData = {
      RepID: RepID,
      Columnnos: "",
      SeqNos: "",
      OrderBySeqs: "",
      Type: Type,
      ReportConfigId: this.ReportConfigId,
     };
    this.http.post(this.url + 'ReportConfig/GetReportColumns', ParanData)
    .subscribe( (data) => {
        if (data == null || data.toString() == "[]") {
          this.MsgType = 2; // No Data Found
          this.DisplayMessage = "No Data Found";
        } else {
          const formGroup = {};
          this.form = new FormGroup(formGroup);
          this.MsgType = 0; // No Message
          this.Cdata = JSON.parse(data.toString());
          formGroup["chkAll"] = new FormControl("");
          (this.form.get("chkAll") as FormControl).patchValue(this.bchkAll);
          this.Cdata.forEach(ColData => {
            formGroup[ColData.ColumnNo] = new FormControl("");
            formGroup[ColData.ColumnName] = new FormControl("");
            formGroup[ColData.OrderByName] = new FormControl("");
            formGroup[ColData.chkName] = new FormControl("");
            this.form = new FormGroup(formGroup);
          });
          for (var val of this.Cdata) {
            (this.form.get(String(val.ColumnNo)) as FormControl).patchValue(val.ColumnNo);
            (this.form.get(String(val.ColumnName)) as FormControl).patchValue(val.SeqNo);
            (this.form.get(String(val.OrderByName)) as FormControl).patchValue(val.OrderBySeq);
            (this.form.get(String(val.chkName)) as FormControl).patchValue(val.IsChecked);
         }
        }
      },
      (error) => {
         this.MsgType = 3; // Error Message
         this.DisplayMessage = error.message;
       }
    );
  }

  onColumnUpdate() {
    this.Columnnos = ""; this.SeqNos = ""; this.OrderBySeqs = "";
    for (var val of this.Cdata) {
      if ( (this.form.get(String(val.chkName)) as FormControl).value == 1)  {

      this.Columnnos += (this.form.get(String(val.ColumnNo)) as FormControl).value + "|";
      this.SeqNos += (this.form.get(String(val.ColumnName)) as FormControl).value + "|";
      this.OrderBySeqs += (this.form.get(String(val.OrderByName)) as FormControl).value + "|";
    }
   }
    let ParanData = {
    RepID: this.RepID,
    Columnnos: this.Columnnos,
    SeqNos: this.SeqNos,
    OrderBySeqs: this.OrderBySeqs,
    Type: 1,
    ReportConfigId: this.ReportConfigId
   };
    this.http.post(this.url + 'ReportConfig/SaveReportColumns', ParanData) .subscribe( (data) => {
     if (data == null) {this.alertService.error(' Updation Failed ' , true);
        }  else {this.alertService.success(' Successfully Updated ' , this.options);
         }
    }
  );
  }

  SelectAll() {
    this.bchkAll =! this.bchkAll;
    for (var val of this.Cdata) {
      (this.form.get(String(val.chkName)) as FormControl).patchValue(this.bchkAll);
  }
}

}

export class ColumnData {
  RepID: string;
  ColumnName: string;
  ColumnNo: number;
  SeqNo: number;
  OrderBySeq: number;
  OrderByName: string;
  IsChecked: boolean;
  chkName: string;
}
